<template>
    <span v-if="typeof last_call != 'undefined'">
        <p>
            Le {{ last_call.ended_at | moment('L') }}
            <span class="timeline-date text-muted" v-if="moment(last_call.ended_at).format('H') !== '0'">
                <small> à {{ last_call.ended_at | moment('H') }}h</small>
            </span>
        </p>
        <timeline-call-widget
            :call="last_call"
        ></timeline-call-widget>
    </span>
    <span v-else>
        <p>Jamais appelé</p>
    </span>
</template>

<script>
import moment from 'moment'
import TimelineCallWidget from "../Customers/Summary/Timeline/TimelineCallWidget.vue"

export default {    
    name: 'last-call-widget',
    components: {
        TimelineCallWidget
    },
    props: ['last_call'],
    data () {
      return {
      }
    },
    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// LastCall.vue?24eae990